// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import '@angular/material/prebuilt-themes/deeppurple-amber.css?global';
// Libraries

// Afidium
import { PopupMenuComponent } from './popup-menu.component';
import { ButtonModule } from '../../module/formbuilder/fields/button/button.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IconNameToDefinitionModule } from "libraries/pipes/icon-name-to-definition/icon-name-to-definition.module";

@NgModule({
    imports: [
        CommonModule,
        MatMenuModule,
        MatButtonModule,
        ButtonModule,
        FontAwesomeModule,
        IconNameToDefinitionModule
    ],
    exports: [
        PopupMenuComponent,
    ],
    declarations: [
        PopupMenuComponent,
    ]
})
export class PopupMenuModule { }
